var urlParams = new URLSearchParams(window.location.search);
jQuery(function ($) {
  jQuery(document).ready(function () {
    
    $(".custom-inn-img").slick({
      rows: 2,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });
  $(".shopify-section--featured-product").wrapAll(
    '<div class="features-prdtsld"></div>'
  );
  $(".features-prdtsld").wrapAll('<div class="features-innersld"></div>');
  setTimeout(function () {
    var x = window.scrollX;
    var y = window.scrollY;

    // if (!urlParams.has('variant')) {
    //   // If 'variant' query parameter is not present, trigger the click event
    //   $("div.block-swatch-list > div:nth-child(2) > label").trigger("click");
    // }

    if (!urlParams.has('variant')) 
    {
      // console.log('Zx - 1 ');
      // If 'variant' query parameter is not present, trigger the click event
      if( urlParams.get('source') == 'google' ) // Added 05/FEB/2025 zx
      {
          // console.log('Zx - 2');
      }
      else
      {
          $("div.block-swatch-list > div:nth-child(2) > label").trigger("click");
          setTimeout(function(){
              $(document).find('.template-product-nutri-product-template-main-2 .appstle_subscription_wrapper > div:last-child .appstle_subscription_radio_wrapper > label').trigger("click");
          }, 500);
          // console.log('Zx - 4');
      }
    }
    else
    {
      setTimeout(function(){
          $(document).find('.template-product-nutri-product-template-main-2 .appstle_subscription_wrapper > div:last-child .appstle_subscription_radio_wrapper > label').trigger("click");
      }, 500);
    }
    
    window.scrollTo(x, y);
    // Initialize the slick slider after the above operations
    $(".features-prdtsld").slick({
      dots: false,
      arrows: true,
      infinite: false,
      centerMode: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: false,
      focusOnChange: false,
      accessibility: false,
    });
    window.scrollTo(x, y);
  }, 800);

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
  });
  $(".pop-close").click(function () {
    $(".popup").fadeOut(500);
    $("body").removeClass("open-customer-pop");
  });
  $(".block-swatch:nth-child(2)").click(function () {
    setTimeout(function () {
      $(".saved-inn-amm span:nth-child(1)").hide();
      $(".saved-inn-amm span:nth-child(2)").show();
      $(".saved-inn-amm span:nth-child(2) .eco-price").show();
      $(".saved-inn-amm span:nth-child(3)").hide();
    }, 150);
  });

  $(".block-swatch:nth-child(3)").click(function () {
    setTimeout(function () {
      $(".saved-inn-amm span:nth-child(1)").hide();
      $(".saved-inn-amm span:nth-child(3)").show();
      $(".saved-inn-amm span:nth-child(3) .eco-price").show();
      $(".saved-inn-amm span:nth-child(2)").hide();
    }, 150);
  });

  $(".block-swatch:nth-child(1)").click(function () {
    setTimeout(function () {
      $(".saved-inn-amm span:nth-child(2)").hide();
      $(".saved-inn-amm span:nth-child(1)").show();
      $(".saved-inn-amm span:nth-child(3)").hide();
    }, 150);
  });

  var width = $(window).width();
  if (width <= 767) {
    // var getprt= $('.product-meta__price-list-container.only-desktop .price-list').html();
    // $('.mob-prc-yet.only-mobile').prepend(getprt);

    $(".two-r").hide();
    $(".thre-r").hide();
    $(".block-swatch:nth-child(2)").click(function () {
      $(".one-r").hide();
      $(".two-r").show();
      $(".thre-r").hide();
    });
    $(".block-swatch:nth-child(3)").click(function () {
      $(".one-r").hide();
      $(".two-r").hide();
      $(".thre-r").show();
    });
    $(".block-swatch:nth-child(1)").click(function () {
      $(".one-r").show();
      $(".two-r").hide();
      $(".thre-r").hide();
    });
  }
  // $('.faq__item:first-child .collapsible-toggle').click();
});

document.addEventListener("DOMContentLoaded", function () {
  const quantiteSelect = document.getElementById("quantite");
  const bouton = document.getElementById("bouton");

  bouton.addEventListener("click", function () {
    const choix = quantiteSelect.value;
    quantiteSelect.blur();
  });


    //const bouton = document.getElementById("bouton");

  //bouton.addEventListener("click", function () {
   // const choix = quantiteSelect.value;
   // quantiteSelect.blur();
 // });

  
});



